// extracted by mini-css-extract-plugin
export default {"container":"AddEvidenceModal__container___fq_go","rightPane":"AddEvidenceModal__rightPane___eBQvS","noSidebarContainer":"AddEvidenceModal__noSidebarContainer___TQI7H"};